import type {
  GenerateRoofVolumeOptions,
  RoofVolumeGenerationResult,
  RoofVolumeGenerationStage,
} from "building-types/roofVolumes/roofVolumeGenerationTypes";
import { generatedRoofVolumeLegacyNew } from "./generateEmptyRoofVolume";
import { generateRoofVolumeBasicParameters } from "./generateRoofVolumeBasicParameters";
import { generateRoofVolumeClippingVolumes } from "./generateRoofVolumeClippingVolumes";
import { generateRoofVolumeEdges } from "./generateRoofVolumeEdges";
import { generateRoofVolumeExtensions } from "./generateRoofVolumeExtensions";
import { generateRoofVolumeExtrusion } from "./generateRoofVolumeExtrusion";
import { generateRoofVolumeGableFaces } from "./generateRoofVolumeGableFaces";
import { generateRoofVolumeHalfFaces } from "./generateRoofVolumeHalfFaces";
import { generateRoofVolumePerimeters } from "./generateRoofVolumePerimeters";
import { generateRoofVolumeRails } from "./generateRoofVolumeRails";
import { generateRoofVolumeSlopes } from "./generateRoofVolumeSlopes";
import { generateRoofVolumeTopFaces } from "./generateRoofVolumeTopFaces";
import { generateRoofVolumeType } from "./generateRoofVolumeType";
import { generateRoofVolumeVerticalRails } from "./generateRoofVolumeVerticalRails";
import { roofVolumeGenerationTemporariesNew } from "./roofVolumeGeneration";

const roofVolumeGenerationStages: RoofVolumeGenerationStage[] = [
  generateRoofVolumeBasicParameters,
  generateRoofVolumePerimeters,
  generateRoofVolumeType,
  generateRoofVolumeSlopes,
  generateRoofVolumeExtensions,
  generateRoofVolumeVerticalRails,
  generateRoofVolumeHalfFaces,
  generateRoofVolumeExtrusion,
  generateRoofVolumeGableFaces,
  generateRoofVolumeRails,
  generateRoofVolumeEdges,
  generateRoofVolumeTopFaces,
  generateRoofVolumeClippingVolumes,
];

export function generateRoofVolumeLegacy(roofVolumeOptions: GenerateRoofVolumeOptions): RoofVolumeGenerationResult {
  let { index } = roofVolumeOptions;

  // create an empty roof volume
  const roofVolume = generatedRoofVolumeLegacyNew(roofVolumeOptions);

  // create empty temporary values
  const temporaries = roofVolumeGenerationTemporariesNew();

  // execute each stage of the roof generation process
  for (const stage of roofVolumeGenerationStages) {
    const {
      roofVolume: newRoofVolume,
      temporaries: newTemporaries = {},
      index: newIndex = index,
    } = stage({
      index,
      roofVolumeOptions,
      roofVolume,
      temporaries,
    });

    Object.assign(roofVolume, newRoofVolume);
    Object.assign(temporaries, newTemporaries);
    index = newIndex;
  }

  return { roofVolume, index };
}
